import React, { useEffect, useState } from "react";
import PaperTypeForm from "../forms/PaperTypeForm";
import { useTab } from "../../../contexts/tab";
import { deleteIcon, editIcon } from "../../icon";
import DeletePaperModal from "../forms/DeletePaperModal";
import TabBodyPaperColor from "./TabBodyPaperColor";
import ShimmerTable from "../../shimmer/ShimmerTable";
import { useAuth } from "../../../contexts/auth";
import { useFormik } from "formik";
import { basePath } from "../../config";
import { toast } from "react-toastify";

export default function TabBodyPaper() {
  const [{ tabData }, { setIsShowPagination, setTabData }] = useTab();
  // console.log({ tabData });
  const [isOpen, setIsOpen] = useState(false);
  const [paperToEdit, setPaperToEdit] = useState(null);
  const [paperToDelete, setPaperToDelete] = useState(null);
  const [{ activeUser }] = useAuth();

  const [paperColorData, setPaperColorData] = useState(null);

  useEffect(() => {
    setIsShowPagination(!paperColorData);
    return () => {
      setIsShowPagination(true);
    };
  }, [paperColorData]);

  function openColorTab({ id, paper, color }) {
    setPaperColorData({ id, paper, color });
  }

  async function submitFormData(values) {
    try {
      const res = await fetch(basePath + "getFilteredPapers", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
        body: JSON.stringify(values),
      });
      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData({ data: JSON.parse(data.data), links: [] });
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  const formik = useFormik({
    initialValues: {
      paper: "",
    },
    onSubmit: (values, actions) => {
      submitFormData(values, actions, activeUser);
    },
  });

  async function handleReset() {
    formik.resetForm({
      core: "",
    });

    setTabData(null);
    const restApi = "getPapers";

    try {
      const res = await fetch(basePath + restApi, {
        method: "post",
        headers: {
          Authorization: `Bearer ${activeUser?.remember_token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData(JSON.parse(data.data));
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  return (
    <div>
      {!paperColorData && (
        <div>
          <div className="flex justify-between bg-slate-200 mb-4 items-center p-2 rounded-md">
            <form
              className="flex gap-3 items-center"
              onSubmit={formik.handleSubmit}
            >
              <label>
                <span className="mr-3">Search:</span>
                <input
                  className="rounded-sm py-1 px-2"
                  value={formik.values.paper}
                  onChange={formik.handleChange}
                  type="text"
                  name="paper"
                  placeholder="Search Paper"
                />
              </label>

              <button className="bg-white rounded-sm px-2 py-1" type="submit">
                Submit
              </button>
              <button
                onClick={handleReset}
                className="bg-white rounded-sm px-2 py-1"
                type="button"
              >
                Reset
              </button>
            </form>
            {activeUser?.user_permission <= 2 && (
              <button
                onClick={() => setIsOpen(true)}
                className="bg-orange text-white p-2 rounded-md"
              >
                Add Paper
              </button>
            )}
          </div>

          {!tabData && <ShimmerTable />}

          {tabData && (
            <table className="dataTable">
              <thead>
                <tr>
                  <th scope="col">No.</th>
                  <th scope="col">Paper</th>
                  <th scope="col">Note</th>
                  {activeUser?.user_permission <= 2 && (
                    <th scope="col">Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {tabData.data.map(({ id, paper, note, color }, i) => {
                  return (
                    <tr
                      key={id}
                      className="cursor-pointer"
                      onClick={() => openColorTab({ id, paper, color })}
                    >
                      <td scope="col">{i + (tabData.from || 1)}</td>
                      <td scope="col">{paper}</td>
                      <td scope="col">{note}</td>
                      {activeUser?.user_permission <= 2 && (
                        <td scope="col">
                          <button
                            className="bg-green-600 p-2 rounded-md my-1"
                            onClick={(e) => {
                              e.stopPropagation();
                              setPaperToEdit({ id, paper, note });
                              setIsOpen(true);
                            }}
                          >
                            {editIcon}
                          </button>
                          <button
                            className="p-2 rounded-md ml-2 bg-orange"
                            onClick={(e) => {
                              e.stopPropagation();
                              setPaperToDelete({ id, paper });
                            }}
                          >
                            {deleteIcon}
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}

          <PaperTypeForm
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            setPaperToEdit={setPaperToEdit}
            paperToEdit={paperToEdit}
          />
          <DeletePaperModal
            paperToDelete={paperToDelete}
            setPaperToDelete={setPaperToDelete}
          />
        </div>
      )}
      {!!paperColorData && (
        <TabBodyPaperColor
          setPaperColorData={setPaperColorData}
          paperColorData={paperColorData}
        />
      )}
    </div>
  );
}
